import {
  FacebookEmbed,
  InstagramEmbed,
  LinkedInEmbed,
  TikTokEmbed,
  TwitterEmbed,
  YouTubeEmbed,
} from "react-social-media-embed";
import styled from "styled-components";

// Social Embed Styles
const spacing = `30px`;
const centerAlign = `display: flex; justify-content: center; margin-top: ${spacing}; margin-bottom: ${spacing};`;
const leftAlign = `display: inline-block; float: left; margin-right: ${spacing}; margin-bottom: ${spacing};`;
const rightAlign = `display: inline-block; float: right; margin-left: ${spacing}; margin-bottom: ${spacing};`;

/**
 * Social Embed Style Component
 */
const SocialEmbedStyle = styled.div`
  @media (max-width: 599px) {
    ${centerAlign}
  }
  @media (min-width: 600px) {
    ${(props) =>
      props.align === "left"
        ? leftAlign
        : props.align === "right"
        ? rightAlign
        : centerAlign}
  }
`;

/**
 * Social Embed Component
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function SocialEmbed(props) {
  const url = props.url ? props.url.trim().toLowerCase() : "";
  const align =
    props.align === "left" || props.align === "right" ? props.align : "center";

  return (
    <SocialEmbedStyle align={align}>
      {(url.includes("facebook.com") || url.includes("fb.watch")) && (
        <FacebookEmbed {...props} />
      )}
      {url.includes("instagram.com") && <InstagramEmbed {...props} />}
      {url.includes("linkedin.com") && <LinkedInEmbed {...props} />}
      {url.includes("tiktok.com") && <TikTokEmbed {...props} />}
      {url.includes("twitter.com") && <TwitterEmbed {...props} />}
      {url.includes("youtube.com") && <YouTubeEmbed {...props} />}
    </SocialEmbedStyle>
  );
}
